import React, { useEffect, useState } from "react";
import { Button, Form, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans, InputDate } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { updateDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import { payrollHelpText } from "../../../payrollHelpText";
import { makeFieldLabel } from "@utils/fieldTooltips";
const langKey = Const["taxStructure"].lngKey
const formName = "createTaxStrutcture";
const taxLabel = makeFieldLabel(payrollHelpText.taxStructure, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
const UpdateTaxStructure = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [errors, setErrors] = useState([]);
  const [slabs, setSlabs] = useState([])
  const [deletedRows, setDeletedRows] = useState([])
  const [form] = Form.useForm()
  useEffect(() => {
    setData()
    // eslint-disable-next-line
  }, []);

  const setData = () => {

    if (props.record.slabs !== undefined) {
      setSlabs(props.record.slabs)
    }
    form.setFieldsValue(
      {
        name: props.record.name,
        fiscal_start: dayjs(props.record.fiscal_start),
        fiscal_end: dayjs(props.record.fiscal_end),
        description: props.record.description,
        slabs: props.record.slabs ? props.record.slabs : []
      }
    )
  }

  const setRows = (key, state) => {
    if (slabs[key] !== undefined && slabs[key].id !== undefined && state === 'Deleted') {
      slabs[key].row_state = 'Deleted'
      deletedRows.push(slabs[key])
    }
    //setDeletedRows(deletedRows)
  }
  const onSubmit = (data) => {
    //update slabs
    let newList = []
    data.slabs.forEach((each) => {
      if (each.id === undefined) {
        each.row_state = 'Added'
      }
      if (each.id !== undefined) {
        each.row_state = 'Updated'
      }
      each.tax_structure_id = props.record.id
      newList.push(each)
    })

    deletedRows.forEach(row => {
      newList.push(row)
    })

    //=========
    const payload = {
      tax_structure:
      {
        id: props.record.id,
        name: data.name,
        fiscal_start: data.fiscal_start.format('YYYY-MM-DD'),
        fiscal_end: data.fiscal_end.format('YYYY-MM-DD'),
        description: data.description,
        slabs: newList
      }

    };
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    message.success("Saved successfully");
    props.onCompleted(data.tax_structures.data);
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    props.disabled ? '' :
      <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } disabled={ props.disabled } scrollToFirstError>
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ taxLabel('name', trans(Commons.name)) }
              className="da-mb-16"
              { ...getErrorProps(errors['name']) } size="small"
            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="fiscal_start" rules={ rules.fiscal_start } label={ taxLabel('fiscal_start') }
              className="da-mb-16"
              { ...getErrorProps(errors['fiscal_start']) } size="small"
            >
              <InputDate />
            </Form.Item>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="fiscal_end" rules={ rules.fiscal_end } label={ taxLabel('fiscal_end') }
              className="da-mb-16"
              { ...getErrorProps(errors['fiscal_end']) } size="small"
            >
              <InputDate />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="description" rules={ rules.description } label={ taxLabel('description', trans(Commons.description)) }
              className="da-mb-16"
              { ...getErrorProps(errors['description']) } size="small"
            >
              <InputTextArea placeholder={ trans(`${langKey}.description`) } />
            </Form.Item>
          </Col>
        </Row>

        <div className="formlist-container">
          <h5 className="formlist-title">{ taxLabel('slabs') }</h5>
          <Form.List name="slabs" >
            { (fields, { add, remove }) => (
              <>
                <Button onClick={ () => {
                  add()
                  setRows(fields.length, 'Added')
                } } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add Item</Button>
                <div className="table-container">
                  <table className="table">
                    {
                      fields.length !== 0 && <thead>
                        <tr>
                          <th style={ { paddingLeft: 20 } }>{ taxLabel('min') }</th>
                          <th>{ taxLabel('max') }</th>
                          <th>{ taxLabel('fixed_amount') }</th>
                          <th>{ taxLabel('percentage') }</th>
                          <th>{ trans(Commons.actions) }</th>
                        </tr>
                      </thead>
                    }
                    <tbody>
                      { fields.map(({ key, name, ...restField }) => (
                        <>
                          <tr>

                            <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                              <Form.Item
                                { ...restField }
                                name={ [name, 'min'] }
                                rules={ rules.min }
                              >
                                <InputText placeholder={ trans(`${langKey}.min`) } type="number" onWheel={(e) => e.target.blur()} />
                              </Form.Item>
                            </td>
                            <td style={ { minWidth: '200px' } }>
                              <Form.Item
                                { ...restField }
                                name={ [name, 'max'] }
                                rules={ rules.max }
                              >
                                <InputText placeholder={ trans(`${langKey}.max`) } type="number" onWheel={(e) => e.target.blur()} />
                              </Form.Item>
                            </td>
                            <td style={ { minWidth: '200px' } }>
                              <Form.Item
                                { ...restField }
                                name={ [name, 'fixed_amount'] }
                                rules={ rules.fixed_amount }
                              >
                                <InputText placeholder={ trans(`${langKey}.fixed_amount`) } type="number" onWheel={(e) => e.target.blur()} />
                              </Form.Item>
                            </td>
                            <td style={ { minWidth: '200px' } }>
                              <Form.Item
                                { ...restField }
                                name={ [name, 'percentage'] }
                                rules={ rules.percentage }
                              >
                                <InputText placeholder={ trans(`${langKey}.percentage`) } type="number" onWheel={(e) => e.target.blur()} />
                              </Form.Item>
                            </td>
                            <td>
                              <DeleteOutlined className="formlist-remove" onClick={ () => {
                                remove(name)
                                setRows(key, 'Deleted')
                              } } />
                            </td>
                          </tr>
                        </>
                      )) }

                    </tbody>
                  </table>
                </div>
              </>
            ) }
          </Form.List>
        </div>
      </Form>
    </ModalComponent>
  )
}

export default UpdateTaxStructure

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  fiscal_start: [
    { required: true, message: trans(`${langKey}.fiscal_start.req`) },
  ],
  fiscal_end: [
    { required: true, message: trans(`${langKey}.fiscal_end.req`) },
  ],
  min: [
    { required: true, message: trans(`${langKey}.min.req`) },
  ],
  max: [
    { required: true, message: trans(`${langKey}.max.req`) },
  ],
  fixed_amount: [
    { required: true, message: trans(`${langKey}.fixed_amount.req`) },
  ],
  percentage: [
    { required: true, message: trans(`${langKey}.percentage.req`) },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
